'use es6';

import { TOGGLE_FOLDER_SELECTION, TOGGLE_ROW_SELECTION } from 'SalesContentIndexUI/data/constants/ActionTypes';
export const toggleFolderSelection = searchResult => dispatch => {
  dispatch({
    type: TOGGLE_FOLDER_SELECTION,
    payload: searchResult
  });
};
export const toggleRowSelection = searchResult => dispatch => {
  dispatch({
    type: TOGGLE_ROW_SELECTION,
    payload: searchResult
  });
};